// src/wherever/Plan.js
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { colors } from '../../style/constants.js';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    position: 'relative',
    padding: 10,
    [theme.breakpoints.down('sm')]: { padding: 6 },

    '& > div': {
      border: '3px solid transparent',
      borderRadius: 12,
      background: colors.WHITE,
      boxShadow: '0px 0px 15px 0px rgba(0,0,0,0.20)',
      position: 'relative',
      overflow: 'hidden',
    },

    '& > svg': {
      transition: 'transform 0.75s',
      position: 'absolute',
      zIndex: 2,
      height: 140,
      [theme.breakpoints.down('sm')]: { height: 110 },
    },
  },

  row: {
    width: '100%',
  },

  left: {
    padding: '22px 22px 18px',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: { padding: 14 },
    '& h3': {
      color: colors.WHITE
    }
  },

  right: {
    padding: '22px',
    borderLeft: '1px solid rgba(0,0,0,0.08)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 14,

    [theme.breakpoints.down('sm')]: {
      borderLeft: 'none',
      borderTop: '1px solid rgba(0,0,0,0.08)',
      padding: 14,
    },
  },

  priceBlock: {
    textAlign: 'center',
    '& h3': {
      margin: 0,
      color: colors.DARK_GREY,
      lineHeight: 1.1,
      '& sup': {
        fontSize: '50%',
        verticalAlign: 'top',
        lineHeight: 1.75,
      },
      '& span': {
        fontSize: '60%',
        marginLeft: 6,
        fontWeight: 500,
      },
    },
    '& h4': {
      margin: '8px 0 0 0',
      color: colors.DARK_GREY,
      fontWeight: 600,
      fontSize: '1.05em',
    },
  },
}));

const Plan = (props) => {
  const classes = useStyles();

  const renderPrice = () => {
    if (props.plan.node.priceType === 'single') {
      return (
        <div className={classes.priceBlock}>
          <h3>
            {props.lang === 'en-CA' ? '$' : ''}
            {props.plan.node.price}
            {props.lang === 'en-CA' ? '' : <sup>$</sup>}
            <span>{props.plan.node.subLabel}</span>
          </h3>
        </div>
      );
    }

    return (
      <div className={classes.priceBlock}>
        <h3>
          {props.plan.node.priceUser}
          <sup>$</sup>
          <span>{props.lang === 'en-CA' ? '/user/month' : '/utilisateur/mois'}</span>
        </h3>
        <h4>
          {props.lang === 'en-CA' ? 'or ' : 'ou '}
          {props.plan.node.priceUnlimited}
          <sup>$</sup> {props.lang === 'en-CA' ? 'unlimited' : 'illimité'}
        </h4>
      </div>
    );
  };

  return (
    <Grid
      className={classes.wrapper}
      item
      xs={12}
    >

      <Grid className={classes.row} container alignItems="stretch">
        {/* LEFT */}
        <Grid item xs={12} md={8} className={classes.left}>
          <h3>{props.plan.node.name}</h3>
        </Grid>

        {/* RIGHT */}
        <Grid item xs={12} md={4} className={classes.right}>
          {renderPrice()}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Plan;
